export default __webpack_public_path__ + "static/media/unlock.1c994058.png";